import { render, staticRenderFns } from "./mailing.vue?vue&type=template&id=c73c2d0e"
import script from "./mailing.vue?vue&type=script&lang=js"
export * from "./mailing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports